import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { ArrowRightIcon } from 'lucide-react';
import { DayScoreBanner } from '../components/activity/DayScoreBanner';
import { TodayPlanPanel } from '../components/activity/TodayPlanPanel';
import { AutoPromptsPanel } from '../components/activity/AutoPromptsPanel';
import { PeriodProgressPanel } from '../components/activity/PeriodProgressPanel';
import { RecentLogList } from '../components/activity/RecentLogList';
import { LogActivityModal } from '../components/activity/LogActivityModal';
import { useActivityPlan } from '../contexts/ActivityPlanContext';
import { loanOfficer } from '../data/officer';
const quickLinks = [{
  to: '/prospects',
  label: 'Realtor Prospects',
  detail: '7 in pipeline · 3 due'
}, {
  to: '/realtors',
  label: 'My Realtors',
  detail: '12 partners · 7 due'
}, {
  to: '/past-clients',
  label: 'Past Clients',
  detail: '6 tracked · 3 overdue'
}, {
  to: '/leads',
  label: 'My Leads',
  detail: '9 total · 4 new'
}];
export function PerfectDayPage() {
  const {
    plan
  } = useActivityPlan();
  const [logOpen, setLogOpen] = useState(false);
  const dateLabel = format(new Date(), 'EEEE, MMMM d, yyyy');
  if (!plan.onboarded) {
    return <main className="w-full px-4 py-5 sm:px-6 sm:py-6 lg:px-8" data-id="element-797" data-mp="3jcj9y934yzq1">
        <div className="mx-auto w-full max-w-2xl rounded-2xl border border-navy-100 bg-white p-6 text-center shadow-card sm:p-10" data-id="element-798" data-mp="3oe8k7mijb9d2">
          <p className="text-xs font-semibold uppercase tracking-wide text-navy-500" data-id="element-799" data-mp="fvud5etcv4dk">
            {dateLabel}
          </p>
          <h1 className="mt-2 text-2xl font-bold tracking-tight text-navy-900" data-id="element-800" data-mp="6x8wjp7g1zff">
            Welcome, {loanOfficer.firstName}. Let’s build your perfect week.
          </h1>
          <p className="mx-auto mt-2 max-w-xl text-sm text-navy-600" data-id="element-801" data-mp="b0nc6erh0dsc">
            Answer five short questions about how you grow business — realtor
            outreach, social engagement, partner meetings, consumer
            conversations, and past-client calls. We turn your answers into daily
            priorities you can log in two taps.
          </p>
          <Link to="/plan" className="mt-6 inline-flex h-11 items-center justify-center rounded-lg bg-brand-600 px-5 text-sm font-semibold text-white hover:bg-brand-700" data-id="element-802" data-mp="x8apkm94q6zj">
            Start my setup
          </Link>
          <p className="mt-3 text-xs text-navy-500" data-id="element-803" data-mp="jfl2eehv6w0u">
            Takes about two minutes · you can change every target later
          </p>
        </div>
      </main>;
  }
  return <main className="w-full px-4 py-5 sm:px-6 sm:py-6 lg:px-8" data-id="element-804" data-mp="eikx45su9xas">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 lg:gap-5" data-id="element-805" data-mp="9i6lkds14580">
        <DayScoreBanner firstName={loanOfficer.firstName} dateLabel={dateLabel} onLogActivity={() => setLogOpen(true)} data-id="element-806" data-mp="4j3szst8jrgx" />

        <div className="flex flex-col gap-4 lg:grid lg:grid-cols-3 lg:items-start lg:gap-5" data-id="element-807" data-mp="23t27siw4zit9">
          <div className="flex flex-col gap-4 lg:col-span-2 lg:gap-5" data-id="element-808" data-mp="1yu8uorkrhttm">
            <TodayPlanPanel data-id="element-809" data-mp="27cua5e9kicb1" />
            <PeriodProgressPanel period="week" data-id="element-810" data-mp="27bj5lc8at0iv" />
            <nav aria-label="Business development lists" data-id="element-811" data-mp="2bdvzn3don9zt">
              <ul className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-812" data-mp="2g5nqzg4nxjr0">
                {quickLinks.map(link => <li key={link.to} data-id="element-813" data-mp="2l4h437g1f8qn">
                    <Link to={link.to} className="group flex h-full items-center justify-between gap-2 rounded-xl border border-navy-100 bg-white px-4 py-3 shadow-card hover:border-brand-300" data-id="element-814" data-mp="2l3flmhwozjyw">
                      <span className="min-w-0" data-id="element-815" data-mp="1xffwfmf141mf">
                        <span className="block truncate text-sm font-semibold text-navy-900" data-id="element-816" data-mp="1xdlac4s0u3gr">
                          {link.label}
                        </span>
                        <span className="block truncate text-xs text-navy-500" data-id="element-817" data-mp="38v4f41l92ehf">
                          {link.detail}
                        </span>
                      </span>
                      <ArrowRightIcon className="h-4 w-4 shrink-0 text-navy-300 group-hover:text-brand-600" aria-hidden="true" data-id="element-818" data-mp="qkp0920hloti" />
                    </Link>
                  </li>)}
              </ul>
            </nav>
          </div>

          <div className="flex flex-col gap-4 lg:gap-5" data-id="element-819" data-mp="umam3cv01dfu">
            <AutoPromptsPanel data-id="element-820" data-mp="uowt9bdz9qxj" />
            <RecentLogList limit={6} data-id="element-821" data-mp="19jb2ik7qplz0" />
          </div>
        </div>
      </div>

      <LogActivityModal open={logOpen} onClose={() => setLogOpen(false)} data-id="element-822" data-mp="14krhcm0z0e7p" />
    </main>;
}